// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__21gOK","unreadBadge":"styles_unreadBadge__1aLgt","modalContent":"styles_modalContent__14VwP","modal":"styles_modal__1_qSp"};